import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { Switch } from "@mui/material";
import PropTypes from "prop-types";
import SoftButton from "components/SoftComponents/SoftButton";

function SystemAppearance({ user, deviceLayout, updateMode }) {
    return (
        <SoftBox px={{xxs: 2, lg: 3}} pb={{xxs: 2, lg: 3}} pt={3} sx={{ borderRadius: "1rem" /*, backgroundColor: "#f9f9f9" */ }}>
            <SoftBox mb={3} textAlign="left">
                <SoftTypography variant="h4" fontWeight="bold">System Visuals</SoftTypography>
            </SoftBox>
            <SoftBox display="flex" flexDirection="column">
                <SoftTypography pl={0.5} variant="caption" fontWeight="bold" textTransform="uppercase">
                    Map Appearance
                </SoftTypography>
                <SoftBox
                    display="flex"
                    p={0.5}
                    mt={1}
                    sx={{
                        backgroundColor: "#eceff1",
                        borderRadius: "0.5rem",
                        width: "fit-content",
                        border: "1px solid #ccc"
                    }}
                >
                    {["light", "dark", "system"].map((mode) => (
                        <SoftButton
                            key={mode}
                            variant={user.user.mode === mode ? "gradient" : "text"}
                            color={user.user.mode === mode ? "info" : "secondary"}
                            size="small"
                            sx={{
                                px: 2,
                                borderRadius: "0.5rem",
                                textTransform: "capitalize",
                                height: 'auto'
                            }}
                            onClick={() => {
                                // console.log("Updating mode to:", mode);
                                if (user.user.mode != mode) {
                                    updateMode(mode);
                                }
                            }}
                        >
                            {mode}
                        </SoftButton>
                    ))}
                </SoftBox>
            </SoftBox>
        </SoftBox>
    );
}


SystemAppearance.propTypes = {
    user: PropTypes.object,
    deviceLayout: PropTypes.string,
    updateMode: PropTypes.func,
}

export default SystemAppearance;